import { useEffect, useState } from "react";
import { AgencyLogo } from "@/components/AgencyLogo";
import { BarometerNav } from "@/components/BarometerNav";

const C = {
  accent: "#6d0000",
  teal: "#115751",
  tealLight: "#11575110",
  border: "#e5e7eb",
  muted: "#6b7280",
};

export default function KontaktDanke() {
  const [countdown, setCountdown] = useState(10);

  // Countdown für optionale Auto-Weiterleitung (nur visuell, kein harter Redirect)
  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <BarometerNav current="/kontakt" accentColor={C.accent} />

      {/* Hero-Bestätigung */}
      <div
        className="w-full py-16 px-6 text-center"
        style={{ backgroundColor: "#000" }}
      >
        {/* Animiertes Häkchen */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: C.teal }}
        >
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
              d="M8 20L16 28L32 12"
              stroke="white"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <p
          className="text-xs font-bold tracking-widest uppercase mb-2"
          style={{ color: C.accent, fontFamily: "'DM Sans', sans-serif" }}
        >
          <AgencyLogo size="sm" />
        </p>
        <h1
          className="font-black uppercase text-white mb-4"
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
          }}
        >
          Anfrage eingegangen!
        </h1>
        <p
          className="text-gray-300 max-w-lg mx-auto text-sm leading-relaxed"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Du erhältst in Kürze eine Bestätigungs-E-Mail. Ich schaue mir deine Situation vorher genau an und melde mich innerhalb von 24h.
        </p>

        {/* Trust-Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          {[
            { icon: "/manus-storage/32_04885248.svg", text: "Kalendereinladung folgt per E-Mail" },
            { icon: "/manus-storage/29_7f3bb394.svg", text: "Persönliche Analyse von Larissa" },
            { icon: "/manus-storage/33_d51b7819.svg", text: "Vorbereitung durch Larissa persönlich" },
          ].map((b, i) => (
            <div
              key={i}
              className="flex items-center gap-2 px-4 py-2 text-xs font-medium"
              style={{
                backgroundColor: "rgba(255,255,255,0.08)",
                color: "#d1d5db",
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              <img src={b.icon} alt="" className="w-5 h-5 object-contain flex-shrink-0" style={{ opacity: 0.85 }} />
              <span>{b.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Cross-Sell: Pro Website-RealitätsCheck */}
      <div className="max-w-2xl mx-auto px-6 py-14">
        <div className="text-center mb-8">
          <p
            className="text-xs font-bold tracking-widest uppercase mb-2"
            style={{ color: C.teal, fontFamily: "'DM Sans', sans-serif" }}
          >
            Während du wartest
          </p>
          <h2
            className="font-black uppercase leading-tight mb-3"
            style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
              color: "#000",
            }}
          >
            Starte jetzt deinen Pro Website-RealitätsCheck
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Damit Larissa deine Website bereits vor der Analyse kennt — für konkrete Maßnahmen auf Basis echter Daten.
          </p>
        </div>

        {/* Vorteile */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {[
            {
              icon: "/manus-storage/23_1ab7147e.svg",
              title: "9 Dimensionen",
              desc: "SEO, Sensorik, Conversion, Datenschutz & mehr",
            },
            {
              icon: "/manus-storage/33_d51b7819.svg",
              title: "Sofort-Vorschau",
              desc: "Ergebnis in Sekunden — ohne Anmeldung",
            },
            {
              icon: "/manus-storage/29_7f3bb394.svg",
              title: "Vollständiger Report",
              desc: "Mit konkreten Handlungsempfehlungen zum Download",
            },
          ].map((v, i) => (
            <div
              key={i}
              className="p-5 text-center"
              style={{ border: `1px solid ${C.border}` }}
            >
              <img src={v.icon} alt="" className="w-9 h-9 mb-3 object-contain" style={{ opacity: 0.85 }} />
              <p
                className="font-bold text-sm mb-1"
                style={{ color: "#000", fontFamily: "'DM Sans', sans-serif" }}
              >
                {v.title}
              </p>
              <p className="text-xs text-gray-500" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {v.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <a
          href="/marketing-realitaetscheck"
          className="flex items-center justify-center gap-2 w-full py-4 font-black uppercase tracking-widest text-white transition-opacity hover:opacity-90"
          style={{
            backgroundColor: C.teal,
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "1.1rem",
          }}
        >
          Jetzt Pro Website-RealitätsCheck starten →
        </a>
        <p className="text-center text-xs text-gray-400 mt-3" style={{ fontFamily: "'DM Sans', sans-serif" }}>
          Vollständiger Report · Persönlich von Larissa analysiert
        </p>

        {/* Zurück-Link */}
        <div className="text-center mt-10">
          <a
            href="/"
            className="text-sm font-medium underline"
            style={{ color: C.muted, fontFamily: "'DM Sans', sans-serif" }}
          >
            ← Zurück zur Startseite
          </a>
        </div>
      </div>

      {/* Footer */}
      <div
        className="border-t py-8 px-6 text-center"
        style={{ borderColor: C.border }}
      >
        <p className="text-xs text-gray-400" style={{ fontFamily: "'DM Sans', sans-serif" }}>
          Deine Daten werden vertraulich behandelt. ·{" "}
          <a href="/datenschutz" style={{ color: C.accent }}>Datenschutzerklärung</a>
        </p>
      </div>
    </div>
  );
}
